import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { EyeOffIcon, EyeOffSmallIcon, EyeIcon, EyeSmallIcon, Signifier } from "@activecollab/components";
import PropTypes from "prop-types";
import { getRawConfigOption } from "~/store/selectors/selector.configOptions.jsx";
import { getLoggedUser } from "~/store/selectors/selector.users.jsx";

const HiddenFromClients = ({ hiddenFromClients, small, className }) => {
  const { t } = useTranslation();
  const defaultHideFromClients = useSelector((state) => getRawConfigOption(state, "default_hide_from_clients"));
  const loggedUser = useSelector(getLoggedUser);

  const renderHideFromClients = useCallback(() => {
    if (loggedUser.class === "Client") return null;
    if (defaultHideFromClients) {
      if (!hiddenFromClients) {
        return (
          <Signifier
            tooltipText={t("Visible to Clients")}
            type={small ? EyeSmallIcon : EyeIcon}
            className={className}
          />
        );
      }
      return null;
    }
    if (hiddenFromClients) {
      return (
        <Signifier
          tooltipText={t("Hidden From Clients")}
          type={small ? EyeOffSmallIcon : EyeOffIcon}
          className={className}
        />
      );
    }
    return null;
  }, [className, defaultHideFromClients, hiddenFromClients, loggedUser.class, small, t]);

  return renderHideFromClients();
};

HiddenFromClients.propTypes = {
  hiddenFromClients: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
};
HiddenFromClients.defaultProps = {
  hiddenFromClients: false,
  small: false,
};

HiddenFromClients.displayName = `HiddenFromClients`;

export default HiddenFromClients;
